import { useEffect, useRef, useState } from "react";
import axios from "../../../shared/config/axios-interceptor";
import { useRouter } from "@/shared/utils/hooks/useRouter";
import { ToastError, ToastSuccess } from "@/components/shared/toast/Toast";
import { CButton, CCol, CLoadingButton, CRow, CSpinner } from "@coreui/react-pro";
import CountdownTimer from "./CountdownTimer";
import { formatUSDNoCurrency, formatVND } from "@/shared/utils/ultils";
import RenderKetQua from "./RenderKetQua";
import RenderAutoDat from "./RenderAutoDat";
import ListGiaPCBottom from "./components/ListGiaPCBottom";
import CountDownPc from "./components/CountDownPc";
import SelectMarketMB from "./components/SelectMarketMB";
import { IoClose } from "react-icons/io5";

const Game = () => {
  const { params } = useRouter();
  const [user, setUser] = useState<any>(null);
  const [game, setGame] = useState(null);
  const [phien, setPhien] = useState<any>(null);
  const [config, setConfig] = useState<any>(null);
  const [ketQuaKyTruoc, setKetQuaKyTruoc] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [money, setMoney] = useState("");
  const [load, setLoad] = useState(false);
  const [laiLo, setLaiLo] = useState<any>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [showBoxDat, setShowBoxDat ] = useState(false);
  const getProfile = async () => {
    try {
      if (params?.userId) {
        const res = await axios.get("/user/" + params?.userId);
        setUser(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getConfig = async () => {
    try {
      const res = await axios.get("/config/1");
      setConfig(res?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getGame = async () => {
    try {
      if (params?.id) {
        const res = await axios.get("/game/" + params?.id);
        setGame(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPhien = async () => {
    try {
      const response = await axios.get("/draws/get-current/" + params?.id);
      setPhien(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getKetQuaKyTruoc = async () => {
    try {
      const response = await axios.get(
        "/draws/get-result-ket-qua-ky-truoc/" + params?.id
      );
      setKetQuaKyTruoc(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getLaiLo = async () => {
    try {
      if (params?.userId) {
        const response = await axios.get("/history/lai-lo/" + params?.userId);
        setLaiLo(response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getConfig();
    getProfile();
    getGame();
    getPhien();
    getKetQuaKyTruoc();
    getLaiLo();
  }, [load]);

  const listCuoc = [
    { name: "LONG", rate: config?.content1 },
    { name: "SHORT", rate: config?.content1 },
    { name: "SINGLE", rate: config?.content1 },
    { name: "DOUBLE", rate: config?.content1 },
    { name: "LS", rate: config?.content2 },
    { name: "SS", rate: config?.content2 },
    { name: "LD", rate: config?.content2 },
    { name: "SD", rate: config?.content2 },
  ];


  const [cuoc, setCuoc] = useState<any>(null);

  if (!params?.userId || !user || !game)
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: "hsl(222.22, 65.85%, 8.04%)",
          }}
        >
          <div className="text-center">
            <p style={{ color: "#fff" }}>Đang vào sảnh...</p>
            <CSpinner color="light" variant="grow" />
          </div>
        </div>
      </>
    );

  const onSubmit = async () => {
    if (!money || Number(money) <= 0 || isNaN(Number(money))) {
      ToastError("Số tiền phải lớn hơn 0");
      return;
    }
    try {
      setLoading(true);
      const res = await axios.post("/history", {
        drawId: phien?.id,
        money,
        userId: params?.userId,
        voted: cuoc?.name,
        rate: cuoc?.rate,
      });

      setLoading(false);
      setMoney("");
      setCuoc(null);
      ToastSuccess("Đặt chip thành công!");
      getProfile();
      getLaiLo();
      setShowBoxDat(false);
      inputRef?.current?.focus();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const renderBienDong = () => {
    if(laiLo?.addMoneyTotal == 0){
      return <span>{formatVND(laiLo?.addMoneyTotal)}</span>
    }

    if(laiLo?.addMoneyTotal > 0){
      return <span className="text-success">+{formatVND(laiLo?.addMoneyTotal)}</span>
    }

    if(laiLo?.addMoneyTotal < 0){
      return <span className="text-danger">-{formatVND(laiLo?.addMoneyTotal)}</span>
    }
  }
  return (
    <div className="page-game">
      <div className="container-custom">
        <div className="px-3 py-1 text-center d-flex justify-content-between align-items-center">
          <div>
            Vòng: {ketQuaKyTruoc?.id}
          </div>
          <CountDownPc phien={phien} load={load} setLoad={setLoad} />
          <div>
             Sau: {phien?.id}
          </div>
        </div>

        <RenderKetQua ketQuaKyTruoc={ketQuaKyTruoc} />

        <div className="py-0">
          <ListGiaPCBottom />
        </div>

        <RenderAutoDat phien={phien} />

        <div className={(showBoxDat ? "d-none" : "d-block")} style={{ position: "fixed", bottom: 0, width: "100%", left: 0, right: 0, textAlign: "center", zIndex: 2 }}>
          <SelectMarketMB />
          <div className="p-3 py-2 mb-3">
            <div className="d-flex align-items-center justify-content-between">
              <p>Lượt tham gia: {laiLo?.moneyTotal}</p>
              <p>Biến Động: {renderBienDong()}</p>
            </div>
          </div>
          <CButton
              onClick={() => setShowBoxDat(true)}
                className="button-dat-cuoc mb-4"
                style={{
                  flexShrink: 0,
                  background: "hsl(49 92% 54%)",
                  color: "#000",
                  fontWeight: "bold",
                }}
              >
                Tham gia
          </CButton>
        </div>
        <div
          className={`box-bottom p-3 ` + (showBoxDat ? "d-flex" : "d-none")}
          style={{ background: "hsl(222.86, 29.58%, 13.92%)", borderRadius: 5, zIndex: 99 }}
        >
          <div className="right w-100 px-1">
            <div className="text-end mb-3 d-flex align-items-center justify-content-between">
              {/* <h6 className="mb-0" style={{ color: "rgb(246, 206, 30)" }}>
                Lựa chọn
              </h6> */}
              <p className="fw-bold" style={{ color: "rgb(246, 206, 30)" }}>Số dư: {formatVND(user?.balance)}</p>
              <div onClick={() => setShowBoxDat(false)}>
                <IoClose style={{ fontSize: 18 }} />
              </div>
            </div>

            <CRow className="g-3 justify-content-center">
              {listCuoc?.map((item, index) => {
                return (
                  <CCol
                    xs={index > 5 ? 6 : 4}
                    md={3}
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={() => setCuoc(item)}
                  >
                    <div
                      className="d-flex p-2 align-items-center justify-content-center gap-2"
                      style={{
                        color: cuoc?.name === item?.name ? "#000" : "#fff",
                        background:
                          cuoc?.name === item?.name
                            ? "hsl(49 92% 54%)"
                            : "rgb(7, 15, 34)",
                        borderRadius: 5,
                      }}
                    >
                      <p className="fw-bold">{item?.name}</p>
                      <p>{item?.rate}</p>
                    </div>
                  </CCol>
                );
              })}
            </CRow>
            
            <div className="d-flex gap-2 mt-3">
              <input
                ref={inputRef}
                value={money}
                onChange={(e) => setMoney(e.target.value)}
                placeholder="Nhập chip"
                className="w-100 px-2"
                type="text"
                style={{
                  borderRadius: 5,
                  width: "100%",
                  background: "transparent",
                  color: "#fff",
                  border: "1px solid #fff",
                  outline: "none",
                  boxShadow: "none",
                }}
              />
              <CLoadingButton
                className="button-dat-cuoc"
                onClick={onSubmit}
                loading={loading}
                disabled={loading || cuoc === null}
                style={{
                  flexShrink: 0,
                  background: "hsl(49 92% 54%)",
                  color: "#000",
                  fontWeight: "bold",
                }}
              >
                Đặt chip
              </CLoadingButton>
            </div>

          </div>
        </div>

        { showBoxDat && <div className="overlayout" style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0, 0, 0, 0.5)", zIndex: 1 }}></div>}

      </div>

      {/* <Layout>
        <HeaderHome />

        <div className="text-center my-3">
          <img width="129" src={game?.imageDesktop ?? ''} />
          <div className="text-white">{game?.name}</div>
        </div>

        <div className="text-center py-2" style={{ background: "rgb(24 59 89)"}}>
          <div style={{color: "rgb(249 114 114)"}}>Kết quả mới nhất</div>
          <div className="d-flex justify-content-center mt-2 gap-1 align-items-center" style={{color: "rgb(249 114 114)"}}>
            {renderKQ()}
          </div>
        </div>


        <KyQuay load={load} ky={ky} setLoad={setLoad} setShowModalDatCuoc={setShowModalDatCuoc} showModalDatCuoc={showModalDatCuoc} />
        <BoxQuay ky={ky} game={game} />

        { 
        showModalDatCuoc ? <div className="box-chon-cuoc">
        <div onClick={() => setShowModalDatCuoc(false)} className="text-end px-3 py-2">
        <i className="fa-solid fa-xmark" style={{ fontSize: 25 }}></i>
        </div>
        <div className="text-center" style={{ fontSize: 12}}>Bấm để chọn kết quả cược, bấm lần nữa để bỏ chọn </div>

        <div className='list-chon'>
          {
            boxCuoc?.map( (item: any, index: number) => {
              return <div
                key={index} 
                // onClick={() => setDaChon(item?.biDatCuocId)} 
                style={{ color: "#000", width: 'fit-content', cursor: "pointer"}}
                className={chonCuoc.some(it => it.biDatCuocId === item.biDatCuocId) ? 'border rounded-5 px-4 py-1 text-center active' : 'border rounded-5 px-4 py-1 text-center'} 
                onClick={() => datCuocHandle(item)}
              >
                <div style={{ color: "#000", fontSize: 14, fontWeight: "bold"}}>{item?.name}</div>
                <div style={{ color: "#000", fontSize: 14, opacity: 0.7}}>{item?.rate}</div>
              </div>
            }) 
          }
        </div>

        <div>
          <input type="text" className="input-datcuoc" placeholder='Nhập số tiền cược' value={soTien} onChange={onChange} style={{ outline: "none"}} />
          <div className="text-center">
          <button disabled={loading} className="button-datcuoc" onClick={() => submitHanler()}>Đặt cược</button>
          </div>
          </div>
        </div> : ""
        }
      </Layout> */}
    </div>
  );

  // if (!game) return null

  // // Game PK
  // if (game.group === 1) {
  //   return <Pk10 game={game} />
  // }

  // // Game XX
  // if (game.group === 2) {
  //   return <Xoso game={game} />
  // }

  // return <Pk10 game={game} />
};

export default Game;
